export const ROOT_CONFIG_FIELDS = [
	'auto_ship',
	'auto_ship_no_return_addr',
	'auto_config_strategy',
	'auto_config_stock_sync',
	'sort_order',
]

export const AFTER_SALE_FIELDS = [
	'auto_apply_aftersale',
	'aftersale_auto_refund',
]

export const SKU_FIELDS = ['sku_outer_id_rule']

// detail 中可能出现的字段别名
export const FIELD_ALIASES = {
	auto_apply_aftersale: ['auto_apply_after_sale'],
	aftersale_auto_refund: ['after_sale_auto_refund'],
	auto_ship_no_return_addr: [
		'auto_ship_no_return_address',
		'auto_ship_without_return_addr',
		'auto_ship_no_channel_return_addr',
		'auto_ship_no_return_address_flag',
	],
	sku_outer_id_rule: ['sku_rule_type', 'rule_type', 'outer_id_rule_type', 'sku_outer_id_rule_type'],
}

// 字段优先查找的嵌套对象
export const FIELD_NESTED_PREFERENCES = {
	auto_download_order: ['order'],
	auto_update_stock: ['order', 'stock'],
	auto_ship: ['order'],
	auto_ship_no_return_addr: ['order', 'after_sale'],
	auto_config_strategy: ['auto_goods', 'goods'],
	auto_config_stock_sync: ['auto_goods', 'goods'],
	sku_outer_id_rule: ['sku'],
}

export function getByPath(obj, path) {
	if (!obj || !path) {
		return undefined
	}
	const parts = path.split('.')
	let cur = obj
	for (let i = 0; i < parts.length; i++) {
		if (cur == null) {
			return undefined
		}
		cur = cur[parts[i]]
	}
	return cur
}

export function setByPath(obj, path, value, vm) {
	const parts = path.split('.')
	const last = parts.pop()
	let cur = obj
	parts.forEach(function(key) {
		if (!cur[key] || typeof cur[key] !== 'object') {
			if (vm) {
				vm.$set(cur, key, {})
			} else {
				cur[key] = {}
			}
		}
		cur = cur[key]
	})
	if (vm) {
		vm.$set(cur, last, value)
	} else {
		cur[last] = value
	}
}

function getFieldKeys(fieldKey) {
	const aliases = FIELD_ALIASES[fieldKey] || []
	return [fieldKey].concat(aliases)
}

function findInObject(obj, fieldKey) {
	const keys = getFieldKeys(fieldKey)
	let i
	let k
	for (i = 0; i < keys.length; i++) {
		k = keys[i]
		if (Object.prototype.hasOwnProperty.call(obj, k)) {
			return k
		}
	}
	return null
}

function getNestedKeys(fieldKey, preferredNestedKey) {
	const nestedKeys = []
	if (preferredNestedKey) {
		nestedKeys.push(preferredNestedKey)
	}
	const prefs = FIELD_NESTED_PREFERENCES[fieldKey] || []
	for (let i = 0; i < prefs.length; i++) {
		if (nestedKeys.indexOf(prefs[i]) === -1) {
			nestedKeys.push(prefs[i])
		}
	}
	return nestedKeys
}

function pathHasValue(form, path) {
	const val = getByPath(form, path)
	return val !== undefined && val !== null && val !== ''
}

function findValuePath(form, fieldKey, preferredNestedKey) {
	if (!form || typeof form !== 'object') {
		return null
	}

	let actualKey = findInObject(form, fieldKey)
	if (actualKey && pathHasValue(form, actualKey)) {
		return actualKey
	}

	const nestedKeys = getNestedKeys(fieldKey, preferredNestedKey)
	let i
	let nestedKey
	for (i = 0; i < nestedKeys.length; i++) {
		nestedKey = nestedKeys[i]
		if (form[nestedKey] && typeof form[nestedKey] === 'object') {
			actualKey = findInObject(form[nestedKey], fieldKey)
			if (actualKey) {
				const path = nestedKey + '.' + actualKey
				if (pathHasValue(form, path)) {
					return path
				}
			}
		}
	}

	for (const key in form) {
		if (!Object.prototype.hasOwnProperty.call(form, key)) {
			continue
		}
		const val = form[key]
		if (!val || typeof val !== 'object' || Array.isArray(val)) {
			continue
		}
		if (nestedKeys.indexOf(key) !== -1) {
			continue
		}
		actualKey = findInObject(val, fieldKey)
		if (actualKey) {
			const path = key + '.' + actualKey
			if (pathHasValue(form, path)) {
				return path
			}
		}
	}

	return null
}

export function resolvePath(form, fieldKey, preferredNestedKey) {
	if (!form || typeof form !== 'object') {
		return preferredNestedKey ? preferredNestedKey + '.' + fieldKey : fieldKey
	}

	// 账户状态固定读取店铺根字段，避免误匹配嵌套对象中的 state
	if (fieldKey === 'state' && Object.prototype.hasOwnProperty.call(form, 'state')) {
		return 'state'
	}

	const valuePath = findValuePath(form, fieldKey, preferredNestedKey)
	if (valuePath) {
		return valuePath
	}

	let actualKey = findInObject(form, fieldKey)
	if (actualKey) {
		return actualKey
	}

	const nestedKeys = getNestedKeys(fieldKey, preferredNestedKey)
	let i
	let nestedKey
	for (i = 0; i < nestedKeys.length; i++) {
		nestedKey = nestedKeys[i]
		if (form[nestedKey] && typeof form[nestedKey] === 'object') {
			actualKey = findInObject(form[nestedKey], fieldKey)
			if (actualKey) {
				return nestedKey + '.' + actualKey
			}
		}
	}

	for (const key in form) {
		if (!Object.prototype.hasOwnProperty.call(form, key)) {
			continue
		}
		const val = form[key]
		if (!val || typeof val !== 'object' || Array.isArray(val)) {
			continue
		}
		actualKey = findInObject(val, fieldKey)
		if (actualKey) {
			return key + '.' + actualKey
		}
	}

	if (preferredNestedKey || nestedKeys.length) {
		return (preferredNestedKey || nestedKeys[0]) + '.' + fieldKey
	}
	return fieldKey
}

export function buildFieldPaths(form) {
	const paths = {}
	ROOT_CONFIG_FIELDS.forEach(function(fieldKey) {
		paths[fieldKey] = resolvePath(form, fieldKey, null)
	})
	SKU_FIELDS.forEach(function(fieldKey) {
		paths[fieldKey] = resolvePath(form, fieldKey, 'sku')
	})
	AFTER_SALE_FIELDS.forEach(function(fieldKey) {
		paths[fieldKey] = resolvePath(form, fieldKey, 'after_sale')
	})
	return paths
}

export function fieldExists(form, path) {
	return getByPath(form, path) !== undefined
}



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/mSetupForm.js